// Core
import React, { useState, useEffect } from "react"
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/all"
import { isMobile } from "react-device-detect"

import { SlideMaskText } from "../slideMaskText"
import { localiseString } from "../../utils/localiseString"

// Styles
import styles from "./episodeMenu.module.scss"

gsap.registerPlugin(ScrollToPlugin)

const EpisodeMenu = ({ toggleMenu, open, hidden, list, current, expired }) => {
  const [loaded, setLoaded] = useState(false),
    [loadedTimeout, setLoadedTimeout] = useState(null)

  const scrollToAnchor = target => {
    let targetEl = document.querySelector(target)

    if (isMobile) {
      gsap.to(window, { duration: 1, scrollTo: targetEl })
    } else {
      window.scroll.scrollTo(targetEl)
    }
  }

  useEffect(() => {
    setLoadedTimeout(
      setTimeout(() => {
        setLoaded(true)
      }, 100)
    )

    return () => {
      if (loadedTimeout) clearTimeout(loadedTimeout)
    }
  }, [])

  return (
    <div
      className={`${styles.wrap} ${open ? styles.open : ""}`}
      data-current={current}
    >
      <ul className={styles.list}>
        <li className={styles.listItem} data-open={open}></li>
        {list.map(data => {
          if (data && data.title === "Performance" && expired) {
            data.title = localiseString("Episode")
          }

          if (data)
            return (
              <li
                className={styles.listItem}
                key={data.id}
                data-slidemasktext
                onClick={() => scrollToAnchor(data.anchorTarget)}
              >
                <SlideMaskText text={data.title} />
              </li>
            )
        })}
      </ul>
      <div
        className={`${styles.toggle} ${loaded && !hidden ? styles.loaded : ""}`}
        onClick={toggleMenu}
      ></div>
    </div>
  )
}

export default EpisodeMenu
